export class IDocumentDetailsDTO {
  benefitPlanName: string;
  memberId: string;
  imageFilename: string;
  tenantName: string;
  authorizationId: string;
  authorizationNumber: string;
  lineIds: string[];
  documentFileName: string;
  documentOrigin: string;
  documentType: string;
  documentTypeId: number;
  documentSource: string;
  communicationType: string;
  createdOn: string;
  createdBy: string;
  authCreatedYear: string;
  productId?: string | null;
}

export class ILetterDetailsDTO extends IDocumentDetailsDTO {
  servicingProvider?: string;
  orderingProvider?: string;
  grievanceDecisionKey: string;
  grievanceDecisionDescription: string;
  dencDetailedExplanationDescription?: string;
  dencFactsDescription?: string;
  dencPlanPolicyProvisionRationaleDescription?: string;
  reopenReason?: string;
  dismissalDate?: string;
  benefitPlanId?: string;
}

export class IFaxDetailsDTO extends IDocumentDetailsDTO {
  attachedDocMetaDataIds?: string[] = [];
  caseId?: string;
  recipientFaxNumber?: string;
  recipientName?: string;
  recipientType?: string;
  providerLocation?: string;
  providerType?: number;
  documentDisplayName: string;
  subject?: string;
  mergeData?: { [key: string]: string | boolean; };
  valid?: boolean;

  // TODO: HH specific for now
  benefitPlanId?: string;
  documentTypeName?: string;
}
